import { LANG_CODE, isSupportedLanguage } from 'constants/language-code'

function getLangFromLocalStorage(){
    let defaultLang = LANG_CODE['ZH'];

    if (typeof(Storage) !== "undefined"){
        let lang = localStorage.getItem("lang");
        if(isSupportedLanguage(lang)){
            return lang;
        }else{
            localStorage.setItem('lang',defaultLang)
        }
    }
    return defaultLang;
}

const initLang = getLangFromLocalStorage();

const initState = {
    lang: initLang,
    langPack:{}
}

const app = (state = initState, action) => {

    switch (action.type) {
    case 'UPDATE_LANG_PACK':
        return {
            ...state,
            langPack: action.langPack,
            lang: action.lang
        }

        default:
            return state
    }
}
export default app



// WEBPACK FOOTER //
// ./src/redux/reducers/app.js